import { render } from "./B2bLoginPasswordFormHipoges.vue?vue&type=template&id=5aa2399e&lang=pug"
import script from "./B2bLoginPasswordFormHipoges.vue?vue&type=script&lang=js"
export * from "./B2bLoginPasswordFormHipoges.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__